import { render, staticRenderFns } from "./VoorhoederDetails.vue?vue&type=template&id=ca6baa4e&"
import script from "./VoorhoederDetails.vue?vue&type=script&lang=js&"
export * from "./VoorhoederDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports